// See tooltip-directive.js for how to use tooltips in VueJS
//
// We've included a drop-in replacement for bootstrap's data-toggle=tooltip usage
// Popper.js will determine the best location (top,right,bottom,left) of the tooltip
// For now we haven't added support for tooltip's with html content, but you can do that manually
// see https://popper.js.org/tooltip-documentation.html
//
// Usage:
//   span data-toggle="tooltip" title="This is the tooltip content" data-placement="bottom"
import type { Options } from 'tooltip.js'

import { default as OriginalTooltip } from 'tooltip.js'

export class Tooltip extends OriginalTooltip {
  constructor(
    element: HTMLElement,
    options?: Options & { size?: 'sm' | 'md' | 'lg' }
  ) {
    const innerClass = `sf-tooltip-inner--${options?.size || 'md'}`
    super(element, {
      ...options,
      template: `<div class="sf-tooltip" role="tooltip"><div class="sf-tooltip-arrow tooltip__arrow"></div><div class="sf-tooltip-inner ${innerClass} tooltip__inner"></div></div>`,
      container: document.body,
    })
  }
}

export default Tooltip
